/* Printer popup (DK, owner 2026-10-08): the rental printer "Myselfie Print" is a public product that customers can buy
   as an add-on to a booking. Wherever it can be added to the cart (its product page, collection / "Flere tilvalg"
   cards) a dialog asks for the booking date, rental period, print type (Polaroid | Fotostribe), logo on the print
   (product "Logo på print") and extra prints (product "Ekstra prints"), then adds printer + logo line + rolls in one go
   and goes to /cart. Same markup, classes and logic as the season-bundle dialog of assets/mys-pdp.js (wholeUi), so the
   styles are assets/mys-pdp.css (loaded on demand on pages that do not have it).
   Lines (what Myselfie.Orders / the cart page read, as the booking module writes them):
     printer   properties Date (DD/MM/YYYY), print_mode (Polaroid | Strip), _reason / _reason_andet (the booking's, when
               the cart has them), "Inkluderet: 400 prints" (KIT.withPrintInfo)
     logo      "Logo på print" variant of logo x print type (Myselfie Logo = 0 kr line)
     prints    "Ekstra prints" x extra rolls, with the "+400 prints per rulle" property
   The order-number rule is untouched (the cart page asks for the number when the cart has no Myselfie booth).
   A booth bundle in the cart that holds its own printer (M-…+MYP…) blocks the dialog (shows what it holds); a printer
   line already in the cart is edited (replaced) instead of doubled. One booking date per order: when the cart has a
   dated line, the dialog uses its date.
   Triggers: any [data-printer-popup] (links keep their href as the no-JS fallback), window.myselfie.printerPopup.open().
   Config: window.myselfie.printerPopupConfig {printer, logo, roll handles, css} from snippets/myselfie-cart-rules.liquid. */
(function () {
  'use strict';

  var M = (window.myselfie = window.myselfie || {});
  var CFG = M.printerPopupConfig;
  if (!CFG || M.printerPopup) return;

  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var PRINT_TYPES = ['Polaroid', 'Fotostribe'];
  var WD = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  var MO = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
  var COMPONENTS = ['Printer'];

  var dlg = null;
  var el = null;
  var data = null; // {printer, logo, roll} in the selector shape
  var choice = null;
  var cart = null;
  var busy = false;
  var opener = null;
  var confirmLabel = 'Læg i kurv og gå til kurven →';

  /* ---------------------------------------------------------------- helpers */
  function kit() { return M.checkoutKit; }
  function seasonKit() { return M.seasonKit; }
  function avail() { return M.availability; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function noop() {}
  function escHtml(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(ore) {
    ore = Math.round(+ore || 0);
    var kr = Math.floor(ore / 100);
    var rest = ore % 100;
    return String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (rest ? ',' + pad(rest) : '') + ' kr';
  }
  function displayToIso(s) {
    var m = String(s || '').match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
    return m ? m[3] + '-' + pad(+m[2]) + '-' + pad(+m[1]) : '';
  }
  function isoToDisplay(iso) { var p = iso.split('-'); return p[2] + '/' + p[1] + '/' + p[0]; }
  function tomorrowIso() { var t = new Date(); t = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1); return t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate()); }
  function longDate(iso) {
    var p = iso.split('-');
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    return WD[d.getDay()] + ' d. ' + d.getDate() + '. ' + MO[d.getMonth()] + ' ' + d.getFullYear();
  }
  function storedIso() {
    var v = '';
    try { v = sessionStorage.getItem('wdn_bookingdate') || ''; } catch (e) { v = ''; }
    var iso = displayToIso(v);
    return iso && iso >= tomorrowIso() ? iso : '';
  }
  function iconCheck() { return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'; }
  function num(n) { return '<span class="mys-pdp-bundle__num" aria-hidden="true">' + n + '</span>'; }
  function frame() { return new Promise(function (r) { requestAnimationFrame(function () { setTimeout(r, 30); }); }); }

  /* ---------------------------------------------------------------- data */
  var loading = null;
  function loadProduct(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product ' + handle); return r.json(); })
      .then(function (p) {
        return {
          handle: p.handle,
          title: p.title,
          options: (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }),
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, title: v.title, price: v.price, sku: v.sku, available: v.available, options: v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }) };
          }),
        };
      });
  }
  function loadData() {
    if (data) return Promise.resolve(data);
    if (!loading) {
      loading = Promise.all([loadProduct(CFG.printer || 'printer'), loadProduct(CFG.logo), loadProduct(CFG.roll)]).then(function (r) {
        if (!r[0] || !r[0].variants.length) throw new Error('no printer');
        data = { printer: r[0], logo: r[1], roll: r[2] };
        return data;
      }, function (err) { loading = null; throw err; });
    }
    return loading;
  }
  function loadCss() {
    if (!CFG.css || document.querySelector('link[href*="mys-pdp.css"]')) return Promise.resolve();
    return new Promise(function (resolve) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = CFG.css;
      var done = function () { resolve(); };
      l.onload = done;
      l.onerror = done;
      document.head.appendChild(l);
      setTimeout(done, 2500);
    });
  }
  function cartGet() {
    var K = kit();
    if (K && K.cartGet) return K.cartGet();
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function cartPost(path, body) {
    var K = kit();
    if (K && K.cartPost) return K.cartPost(path, body);
    return fetch(ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw { status: r.status, message: b.description || b.message }; return b; }); });
  }

  /* ---------------------------------------------------------------- options (printer: Varighed; logo: Logo x Print type) */
  function durIndex() {
    var o = data.printer.options;
    for (var i = 0; i < o.length; i++) if (/varighed/i.test(o[i])) return i;
    return 0;
  }
  function durOf(v) { return v ? String(v.options[durIndex()] || '') : ''; }
  function durations() {
    var out = [];
    data.printer.variants.forEach(function (v) { var d = durOf(v); if (d && out.indexOf(d) < 0) out.push(d); });
    return out;
  }
  /** Weekend rentals are Friday-Sunday: a Monday-Thursday date is a weekday rental (as the booking module). */
  function effDuration() {
    var d = choice.duration || durations()[0] || 'Weekend';
    if (choice.iso && /weekend/i.test(d)) {
      var wd = new Date(+choice.iso.slice(0, 4), +choice.iso.slice(5, 7) - 1, +choice.iso.slice(8, 10)).getDay();
      if (wd >= 1 && wd <= 4) {
        var list = durations();
        for (var i = 0; i < list.length; i++) if (/1 hverdag/i.test(list[i])) return list[i];
      }
    }
    return d;
  }
  /** The printer variant of a rental period on a day ('' = no date: the default season), null when it does not exist. */
  function printerVariant(day, duration) {
    var k = seasonKit();
    var want = { duration: duration || effDuration(), iso: day || '', strict: true };
    if (k) return k.pick(data.printer, want);
    return data.printer.variants.filter(function (v) { return durOf(v) === want.duration; })[0] || null;
  }
  function minPrice(d) {
    var min = null;
    data.printer.variants.forEach(function (v) { if (durOf(v) === d && (min === null || v.price < min)) min = v.price; });
    return min;
  }
  function logoVariant(code, day) {
    var K = kit();
    return data.logo && K && K.pickLogo ? K.pickLogo(data.logo, code || 'ML', choice.printType, day || '') : null;
  }
  function logoLabel(code) {
    var K = kit();
    return data.logo && K && K.logoName ? K.logoName(data.logo, code) : ({ ML: 'Myselfie Logo', NL: 'Ingen logo', EL: 'Eget logo' })[code];
  }
  function rollVariant(day) {
    var r = data.roll;
    if (!r || !r.variants || !r.variants.length) return null;
    var k = seasonKit();
    return (k ? k.pick(r, { iso: day || '' }) : null) || r.variants[0];
  }
  function maxRolls() {
    var ps = document.querySelector('myselfie-product-selector[data-max-rolls]');
    return Number(ps && ps.getAttribute('data-max-rolls')) || 5;
  }
  function maxPrints() { return rollVariant('') ? 400 + 400 * maxRolls() : 400; }
  function extraRolls() { return Math.max(0, Math.round((choice.prints - 400) / 400)); }
  function printModeOf(type) {
    var K = kit();
    return K && K.printModeOf ? K.printModeOf(type) : (/foto|strip/i.test(type) ? 'Strip' : 'Polaroid');
  }

  /** [{label, detail, amount, sub, variant, qty}] for a day, or null when the printer cannot be sold then. */
  function linesFor(day) {
    var pv = printerVariant(day);
    if (!pv) return null;
    var d = effDuration();
    var out = [{ label: 'Printer', detail: [d, choice.printType, '400 prints'].join(' · '), amount: pv.price, variant: pv }];
    var lv = logoVariant(choice.logo, day);
    if (!lv && choice.logo !== 'ML') return null;
    // one "Logo på print" line with every printer (Myselfie Logo = 0 kr), shown under the printer
    if (lv) out.push({ label: 'Logo på print', detail: [choice.printType, logoLabel(choice.logo)].join(' · '), amount: lv.price, sub: true, variant: lv });
    var extra = extraRolls();
    var rv = extra ? rollVariant(day) : null;
    if (extra && rv) out.push({ label: 'Ekstra prints', detail: extra + ' × 400', amount: rv.price * extra, variant: rv, qty: extra });
    return out;
  }
  function sum(lines) { return (lines || []).reduce(function (n, l) { return n + l.amount; }, 0); }

  /* ---------------------------------------------------------------- what the cart holds */
  function cameraType() {
    return (M.cartRules && M.cartRules.cameraType) || (M.orderRule && M.orderRule.cameraType) || 'Myselfie';
  }
  function freePropsId() { return M.cartRules && M.cartRules.freeProps; }
  function isAuto(it) {
    if (freePropsId() && it.variant_id === freePropsId()) return true;
    return Object.keys(it.properties || {}).some(function (k) { return k.indexOf('__upcart') === 0; });
  }
  function isCamera(it) { return !isAuto(it) && it.product_type === cameraType(); }
  function sku(it) { return String(it.sku || '').trim().toUpperCase(); }
  function inProduct(p, it) { return !!p && !!p.variants && p.variants.some(function (v) { return v.id === it.variant_id; }); }
  function isLogoLine(it) { return inProduct(data.logo, it) || /^LOGO-/.test(sku(it)); }
  function isRollLine(it) { return inProduct(data.roll, it) || /^XPR/.test(sku(it)); }
  function isPrinterLine(it) { return !isCamera(it) && (/^(MYP|QP)/.test(sku(it)) || inProduct(data.printer, it)); }
  function hasPrinterPart(it) { return /(^|\+)MYP/.test(sku(it)); }
  /** {remove, bundle (camera line that holds a printer), printer (existing printer line), ref (line with the booking's Date), date (iso)} */
  function plan(c) {
    var items = ((c && c.items) || []).filter(function (it) { return !isAuto(it); });
    var bundle = items.filter(function (it) { return isCamera(it) && hasPrinterPart(it); })[0] || null;
    var printer = items.filter(isPrinterLine)[0] || null;
    var remove = bundle ? [] : items.filter(function (it) { return isPrinterLine(it) || isLogoLine(it) || isRollLine(it); });
    var ref = null;
    items.forEach(function (it) {
      var d = it.properties && it.properties.Date;
      if (!d || !displayToIso(d)) return;
      if (!ref || (isCamera(it) && !isCamera(ref))) ref = it;
    });
    return { remove: remove, bundle: bundle, printer: printer, ref: ref, items: items, camera: items.some(isCamera) };
  }
  function lockedIso(p) {
    var iso = p.ref ? displayToIso(p.ref.properties.Date) : '';
    return iso && iso >= tomorrowIso() ? iso : '';
  }
  /** Pre-fill from the printer line already in the cart ("Ret printer"). */
  function fromCart(p, c) {
    var mine = p.printer;
    if (!mine) return;
    (mine.options_with_values || []).forEach(function (o) {
      if (/varighed/i.test(o.name) && durations().indexOf(o.value) > -1) choice.duration = o.value;
    });
    var mode = mine.properties && mine.properties.print_mode;
    if (mode) choice.printType = /strip|stribe/i.test(mode) ? 'Fotostribe' : 'Polaroid';
    var items = (c && c.items) || [];
    var logo = items.filter(isLogoLine)[0];
    var K = kit();
    var lv = logo && data.logo ? data.logo.variants.filter(function (v) { return v.id === logo.variant_id; })[0] : null;
    var m = logo ? /^LOGO-(EL|NL|ML)/.exec(sku(logo)) : null;
    var code = lv && K && K.logoCode ? K.logoCode(lv, data.logo) : m ? m[1] : '';
    if (code) choice.logo = code;
    var rolls = items.filter(isRollLine).reduce(function (n, it) { return n + it.quantity; }, 0);
    choice.prints = Math.min(maxPrints(), 400 + 400 * rolls);
  }

  /* ---------------------------------------------------------------- dialog */
  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'mys-pdp-bundle mys-pdp-section mys-printer-popup';
    dlg.id = 'mys-printer-popup';
    dlg.setAttribute('aria-labelledby', 'mys-printer-popup-title');
    dlg.setAttribute('aria-describedby', 'mys-printer-popup-sub');
    dlg.innerHTML =
      '<div class="mys-pdp-bundle__inner">' +
        '<header class="mys-pdp-bundle__head"><div>' +
          '<p class="mys-eyebrow">Tilvalg til din Myselfie</p>' +
          '<h2 class="mys-pdp-bundle__title" id="mys-printer-popup-title" data-pp-title>Myselfie Print</h2>' +
          '<p class="mys-pdp-bundle__sub" id="mys-printer-popup-sub">Vælg dato, lejeperiode, print og logo – så lægger vi printeren i kurven.</p>' +
        '</div>' +
        '<button type="button" class="mys-pdp-bundle__close" data-pp-close aria-label="Luk"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '</header>' +
        '<div class="mys-pdp-bundle__body">' +
          '<div data-pp-existing></div>' +
          '<section class="mys-pdp-bundle__step" data-pp-date-step>' +
            '<h3 class="mys-pdp-bundle__label"><span class="mys-pdp-bundle__num" aria-hidden="true">1</span>Dato for jeres fest</h3>' +
            '<div class="mys-pdp-bundle__known" data-pp-known hidden>' +
              '<p><strong data-pp-date-text></strong> <span class="mys-pdp-bundle__lock" data-pp-lock hidden>– samme dato som jeres booking</span></p>' +
              '<button type="button" class="mys-link mys-pdp-bundle__change" data-pp-change>Skift dato</button>' +
            '</div>' +
            '<div class="mys-pdp-bundle__pick" data-pp-pick hidden>' +
              '<div class="mys-pdp__date-field">' +
                '<myselfie-datepicker data-source="printer" data-availability-products="Printer">' +
                  '<input type="text" id="mys-printer-popup-date" class="mys-pdp__date-input" placeholder="Vælg dato" autocomplete="off" aria-label="Dato for jeres fest" data-pp-date>' +
                '</myselfie-datepicker>' +
                '<span class="mys-pdp__date-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="5" width="17" height="15.5" rx="2.5"/><path d="M3.5 10h17M8 3v4M16 3v4"/></svg></span>' +
              '</div>' +
            '</div>' +
            '<p class="mys-pdp-bundle__status" data-pp-status aria-live="polite"></p>' +
          '</section>' +
          '<div data-pp-options></div>' +
          '<section class="mys-pdp-bundle__sum" aria-live="polite">' +
            '<h3 class="mys-pdp-bundle__label">Det lægger vi i kurven</h3>' +
            '<div data-pp-summary></div>' +
          '</section>' +
        '</div>' +
        '<footer class="mys-pdp-bundle__foot">' +
          '<p class="mys-pdp-bundle__err" role="alert" data-pp-err hidden></p>' +
          '<button type="button" class="mys-btn mys-pdp-bundle__cta" data-pp-confirm>' + confirmLabel + '</button>' +
          '<p class="mys-pdp-bundle__fine">Gratis fragt og forsikring · Du betaler først i kassen</p>' +
        '</footer>' +
      '</div>';
    document.body.appendChild(dlg);
    var $ = function (sel) { return dlg.querySelector(sel); };
    el = {
      title: $('[data-pp-title]'), existing: $('[data-pp-existing]'), step: $('[data-pp-date-step]'), known: $('[data-pp-known]'), pick: $('[data-pp-pick]'),
      dateText: $('[data-pp-date-text]'), lock: $('[data-pp-lock]'), change: $('[data-pp-change]'), input: $('[data-pp-date]'),
      status: $('[data-pp-status]'), options: $('[data-pp-options]'), summary: $('.mys-pdp-bundle__sum'), sumBody: $('[data-pp-summary]'),
      err: $('[data-pp-err]'), confirm: $('[data-pp-confirm]'),
    };

    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('mys-pdp-bundle-open');
      if (opener) { try { opener.focus(); } catch (e) { /* ignore */ } }
    });
    dlg.addEventListener('cancel', function (e) { if (busy) e.preventDefault(); });
    dlg.addEventListener('click', function (e) {
      if (!choice) return;
      if (e.target === dlg) return close(); // the backdrop
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      if (t.closest('[data-pp-close]')) return close();
      if (t.closest('[data-pp-change]')) {
        choice.picking = true;
        render();
        setTimeout(function () { try { el.input.focus(); } catch (err) { /* ignore */ } }, 0);
        return;
      }
      if (t.closest('[data-pp-confirm]')) return confirm();
      var setBtn = t.closest('[data-bundle-set]');
      if (setBtn && !busy) {
        var name = setBtn.getAttribute('data-bundle-set');
        var value = setBtn.getAttribute('data-value');
        choice[name] = value;
        showErr('');
        render();
        var btns = dlg.querySelectorAll('[data-bundle-set="' + name + '"]');
        for (var i = 0; i < btns.length; i++) if (btns[i].getAttribute('data-value') === value) btns[i].focus();
        return;
      }
      var pr = t.closest('[data-bundle-prints]');
      if (pr && !pr.disabled && !busy) {
        choice.prints = Math.max(400, Math.min(maxPrints(), choice.prints + Number(pr.getAttribute('data-bundle-prints'))));
        render();
        var same = dlg.querySelector('[data-bundle-prints="' + pr.getAttribute('data-bundle-prints') + '"]');
        if (same && !same.disabled) same.focus();
      }
    });
    // the dialog's own date picker: chosen here, applied to the booking (header, cart) only on "Læg i kurv"
    window.addEventListener('myselfie:date', function (e) {
      var d = (e && e.detail) || {};
      if (d.source !== 'printer') return;
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }, true);
    el.input.addEventListener('change', function () {
      var iso = displayToIso(el.input.value);
      if (iso && choice) {
        choice.iso = iso;
        choice.picking = false;
        showErr('');
        render();
      }
    });
  }

  function showErr(msg) {
    el.err.textContent = msg || '';
    el.err.hidden = !msg;
  }
  /** Why the date cannot be booked for the printer ('' = fine). */
  function problem(iso) {
    if (!iso) return '';
    if (iso < tomorrowIso()) return 'Vælg en dato fra i morgen.';
    var a = avail();
    var day = longDate(iso);
    if (a && a.data && typeof a.isLead === 'function' && a.isLead(iso, COMPONENTS)) return 'Vi kan ikke levere så hurtigt – vælg en senere dato.';
    if (a && a.data && a.statusFor(iso, COMPONENTS) === 'sold_out') return 'Printeren er udsolgt ' + day + ' – vælg en anden dato.';
    var pv = printerVariant(iso);
    if (!pv) return 'Printeren findes ikke som ' + effDuration().toLowerCase() + '.';
    if (pv.available === false) return 'Printeren er udsolgt som ' + effDuration().toLowerCase() + ' – vælg en anden lejeperiode.';
    return '';
  }
  function statusText(iso) {
    var a = avail();
    var st = a && a.data ? a.statusFor(iso, COMPONENTS) : 'available';
    var t = st === 'low' ? 'Få tilbage' : 'Ledig';
    var d = effDuration();
    if (d !== choice.duration) t += ' · ' + d.toLowerCase() + ' (weekend-leje gælder fredag–søndag)';
    return { text: t, state: st === 'low' ? 'low' : 'available' };
  }
  function seg(name, label, values, on, priceOf) {
    return '<fieldset class="mys-pdp-bundle__step"><legend class="mys-pdp-bundle__label">' + label + '</legend>' +
      '<div class="mys-pdp-bundle__seg" role="radiogroup" aria-label="' + escHtml(label.replace(/<[^>]+>/g, '')) + '">' +
      values.map(function (v) {
        var is = v.value === on;
        var price = priceOf ? priceOf(v) : '';
        return '<button type="button" role="radio" aria-checked="' + is + '" class="mys-pdp-bundle__opt' + (is ? ' is-on' : '') + '" data-bundle-set="' + name + '" data-value="' + escHtml(v.value) + '">' +
          '<span>' + escHtml(v.label) + '</span>' + (price ? '<small>' + price + '</small>' : '') + '</button>';
      }).join('') + '</div></fieldset>';
  }
  function setHtml(node, html) { if (node._html !== html) { node._html = html; node.innerHTML = html; } }

  function render() {
    var p = plan(cart);
    var blocked = !!p.bundle;
    var iso = choice.iso;
    var picking = !iso || choice.picking;
    el.step.hidden = blocked;
    el.options.hidden = blocked;
    el.summary.hidden = blocked;
    // the existing state of the cart
    var ex = '';
    if (blocked) {
      var bd = p.bundle.properties && p.bundle.properties.Date;
      ex = '<p class="mys-pdp-bundle__incl">' + iconCheck() + '<span>Printeren er allerede med i »' + escHtml(p.bundle.product_title) + '« i kurven' + (bd ? ' (d. ' + escHtml(bd) + ')' : '') + '. Print type, logo og antal prints ændrer I på pakken i kurven – så får I ikke to printere.</span></p>';
    } else if (p.printer) {
      var pd = p.printer.properties && p.printer.properties.Date;
      ex = '<p class="mys-pdp-bundle__incl">' + iconCheck() + '<span>I har allerede en printer i kurven' + (pd ? ' (d. ' + escHtml(pd) + ')' : '') + '. Den bliver opdateret med jeres valg herunder – ikke lagt til en gang til.</span></p>';
    }
    setHtml(el.existing, ex);
    el.known.hidden = picking;
    el.pick.hidden = !picking;
    if (iso) el.dateText.textContent = longDate(iso);
    el.lock.hidden = !choice.locked;
    el.change.hidden = !!choice.locked;
    var prob = problem(iso);
    if (iso && !prob) {
      var st = statusText(iso);
      el.status.textContent = st.text;
      el.status.setAttribute('data-state', st.state);
    } else {
      el.status.textContent = prob ? prob + (choice.locked ? ' Ret datoen på jeres booking i kurven først.' : '') : (iso ? '' : 'Vælg datoen – udsolgte datoer kan ikke vælges.');
      el.status.setAttribute('data-state', prob ? 'sold_out' : 'hint');
    }
    if (blocked) {
      setHtml(el.options, '');
      setHtml(el.sumBody, '');
      el.confirm.disabled = busy;
      if (!busy) el.confirm.textContent = 'Gå til kurven →';
      return;
    }
    var day = iso && !prob ? iso : '';
    var html = '';
    var n = 2;
    var durs = durations();
    if (durs.length > 1) {
      html += seg('duration', num(n++) + 'Lejeperiode', durs.map(function (d) { return { value: d, label: d }; }), choice.duration, function (o) {
        if (!day) { var m = minPrice(o.value); return m == null ? '' : 'fra ' + escHtml(fmt(m)); }
        var pv = printerVariant(day, o.value);
        return pv ? escHtml(fmt(pv.price)) : '';
      });
    }
    html += seg('printType', num(n++) + 'Print type', PRINT_TYPES.map(function (t) { return { value: t, label: t }; }), choice.printType);
    var logos = ['ML', 'NL', 'EL'].map(function (c) { return { value: c, label: logoLabel(c) }; })
      .filter(function (o) { var lv = logoVariant(o.value, day); return o.value === 'ML' || (lv && lv.available !== false); });
    html += seg('logo', num(n++) + 'Logo på print', logos, choice.logo, function (o) {
      var lv = logoVariant(o.value, day);
      return lv && lv.price ? '+' + escHtml(fmt(lv.price)) : 'gratis';
    });
    if (choice.logo === 'EL') html += '<p class="mys-pdp-bundle__help">Eget logo: I lægger logoet ind i galleriet efter bestillingen.</p>';
    var max = maxPrints();
    var roll = rollVariant(day);
    html += '<div class="mys-pdp-bundle__step"><p class="mys-pdp-bundle__label" id="mys-printer-popup-prints-l">' + num(n++) + 'Antal prints</p>' +
      '<div class="mys-pdp__stepper mys-pdp-bundle__stepper" role="group" aria-labelledby="mys-printer-popup-prints-l">' +
        '<button type="button" data-bundle-prints="-400" aria-label="400 færre prints"' + (choice.prints <= 400 ? ' disabled' : '') + '>−</button>' +
        '<output aria-live="polite">' + choice.prints + '</output>' +
        '<button type="button" data-bundle-prints="400" aria-label="400 flere prints"' + (choice.prints >= max ? ' disabled' : '') + '>+</button>' +
      '</div>' +
      '<p class="mys-pdp-bundle__help">Inkluderet: 400 prints.' + (roll ? ' Ekstra ruller: ' + escHtml(fmt(roll.price)) + ' pr. 400 prints.' : '') + '</p></div>';
    if (!p.camera) {
      html += '<p class="mys-pdp-bundle__help">Printeren sendes sammen med en Myselfie. Har I ikke en Myselfie i kurven, skal I angive ordrenummeret fra jeres booking i kurven.</p>';
    }
    setHtml(el.options, html);

    var sumHtml = '';
    if (day) {
      var lines = linesFor(day);
      if (lines) {
        sumHtml = '<ul class="mys-pdp-bundle__lines" role="list">' + lines.map(function (l) {
          if (l.sub) return '<li class="mys-pdp-bundle__sub"><span><small>' + escHtml(l.label + ': ' + l.detail) + '</small></span><span>' + (l.amount ? escHtml(fmt(l.amount)) : 'Gratis') + '</span></li>';
          return '<li><span>' + escHtml(l.label) + (l.detail ? ' <small>' + escHtml(l.detail) + '</small>' : '') + '</span><span>' + escHtml(fmt(l.amount)) + '</span></li>';
        }).join('') + '</ul><p class="mys-pdp-bundle__total"><span>I alt inkl. moms</span><strong data-pp-total>' + escHtml(fmt(sum(lines))) + '</strong></p>' +
          '<p class="mys-pdp-bundle__help">Prisen gælder ' + escHtml(longDate(day)) + '.</p>';
      } else sumHtml = '<p class="mys-pdp-bundle__help">Printeren kan ikke bookes på denne dato – vælg en anden dato.</p>';
    } else {
      var lo = minPrice(effDuration());
      var extras = 0;
      var lv0 = logoVariant(choice.logo, '');
      if (lv0) extras += lv0.price;
      var rv0 = extraRolls() ? rollVariant('') : null;
      if (rv0) extras += rv0.price * extraRolls();
      sumHtml = '<p class="mys-pdp-bundle__total"><span>I alt inkl. moms</span><strong data-pp-total>' + (lo != null ? escHtml(fmt(lo + extras)) : '–') + '</strong></p>' +
        '<p class="mys-pdp-bundle__help">Prisen afhænger af datoen.</p>';
    }
    setHtml(el.sumBody, sumHtml);
    el.confirm.disabled = busy || !iso || !!prob || !linesFor(iso);
    if (!busy) el.confirm.textContent = p.printer ? 'Opdatér printer og gå til kurven →' : confirmLabel;
  }

  function snapshot(r) {
    var x = { id: r.variant_id, quantity: r.quantity };
    var rp = {};
    Object.keys(r.properties || {}).forEach(function (k) { if (k.indexOf('__') !== 0) rp[k] = r.properties[k]; });
    if (Object.keys(rp).length) x.properties = rp;
    return x;
  }
  function close() {
    if (busy) return;
    if (dlg && dlg.open) dlg.close();
  }

  async function confirm() {
    if (busy || !choice) return;
    if (plan(cart).bundle) { location.href = ROOT + 'cart'; return; }
    if (!choice.iso) { showErr('Vælg datoen for jeres fest først.'); choice.picking = true; render(); return; }
    var prob = problem(choice.iso);
    if (prob) { showErr(prob); return; }
    busy = true;
    showErr('');
    el.confirm.disabled = true;
    el.confirm.textContent = 'Lægger i kurven…';
    var display = isoToDisplay(choice.iso);
    var removed = [];
    var K = kit();
    var ADD = (K && K.QUIET_ADD) || 'cart/add.js';
    try {
      var c = await cartGet();
      cart = c;
      var p = plan(c);
      if (p.bundle) throw { message: 'Printeren er allerede med i pakken i kurven.' };
      var lines = linesFor(choice.iso);
      if (!lines) throw { message: 'Printeren kan ikke bookes på denne dato – vælg en anden dato.' };
      var old = (p.ref && p.ref.properties) || {};
      if (p.ref && old.Date && old.Date !== display) throw { message: 'Jeres kurv har en booking d. ' + old.Date + '. Alt i en ordre har samme dato – ret datoen i kurven først.' };
      var props = { Date: display, print_mode: printModeOf(choice.printType) };
      if (old._reason) { props._reason = old._reason; props._reason_andet = old._reason_andet || ''; }
      var pv = lines[0].variant;
      if (K && K.withPrintInfo) props = K.withPrintInfo(props, pv.sku);
      var adds = [{ id: pv.id, quantity: 1, properties: props }];
      lines.slice(1).forEach(function (l) {
        var x = { id: l.variant.id, quantity: l.qty || 1 };
        var lp = K && K.withPrintInfo ? K.withPrintInfo(null, l.variant.sku) : null;
        if (lp && Object.keys(lp).length) x.properties = lp;
        adds.push(x);
      });
      // the printer that is replaced goes first (an identical line would otherwise merge with the new one)
      for (var i = 0; i < p.remove.length; i++) {
        await cartPost('cart/change.js', { id: p.remove[i].key, quantity: 0 });
        removed.push(p.remove[i]);
      }
      try {
        await cartPost(ADD, { items: adds });
      } catch (addErr) {
        if (removed.length) await cartPost(ADD, { items: removed.map(snapshot) }).catch(noop); // the old printer back
        throw { message: addErr && addErr.status === 422 && addErr.message ? addErr.message : 'Printeren kunne ikke lægges i kurven. Prøv igen om et øjeblik.' };
      }
      try { sessionStorage.setItem('wdn_bookingdate', display); } catch (e) { /* ignore */ }
      try { document.dispatchEvent(new CustomEvent('myselfie:date', { detail: { iso: choice.iso, display: display, source: 'printer-confirm' } })); } catch (e) { /* ignore */ }
      var done = await cartGet().catch(function () { return null; });
      if (done && K && K.cartDetail) { try { document.dispatchEvent(new CustomEvent('myselfie:cart', { detail: K.cartDetail(done) })); } catch (e) { /* ignore */ } }
      location.href = ROOT + 'cart';
    } catch (err) {
      busy = false;
      cartGet().then(function (c2) { cart = c2; if (dlg.open) render(); }, noop);
      showErr((err && err.message && !(err instanceof Error)) ? err.message : 'Noget gik galt. Prøv igen om et øjeblik.');
      render();
    }
  }

  /* ---------------------------------------------------------------- open */
  var opening = false;
  /** opts: {trigger: element to give the focus back to, duration: preselected rental period} */
  function open(opts) {
    opts = opts || {};
    if (opening || (dlg && dlg.open)) return Promise.resolve();
    opening = true;
    opener = opts.trigger || null;
    var label = opener && opener.querySelector ? (opener.querySelector('[data-pdp-cta-label], [data-rek-label]') || opener) : null;
    var before = label ? label.textContent : '';
    if (label) label.textContent = 'Øjeblik…';
    var a = avail();
    return Promise.all([loadData(), cartGet(), loadCss(), a && typeof a.load === 'function' ? a.load().catch(noop) : null]).then(function (r) {
      if (label) label.textContent = before;
      cart = r[1];
      if (!dlg) build();
      var p = plan(cart);
      var lock = lockedIso(p);
      choice = {
        iso: lock || storedIso(),
        locked: !!lock,
        picking: false,
        duration: opts.duration && durations().indexOf(opts.duration) > -1 ? opts.duration : durations()[0],
        printType: PRINT_TYPES[0],
        logo: 'ML',
        prints: 400,
      };
      fromCart(p, cart);
      if (choice.iso && problem(choice.iso) && !choice.locked) choice.picking = true; // a remembered date that cannot be booked: ask
      el.title.textContent = data.printer.title || 'Myselfie Print';
      el.input.value = choice.iso ? isoToDisplay(choice.iso) : '';
      busy = false;
      showErr('');
      render();
      dlg.showModal();
      document.documentElement.classList.add('mys-pdp-bundle-open');
      var t = p.bundle ? el.confirm : dlg.querySelector('.mys-pdp-bundle__title');
      if (t) { if (t === el.title) t.setAttribute('tabindex', '-1'); try { t.focus(); } catch (e) { /* ignore */ } }
      opening = false;
    }).catch(function () {
      opening = false;
      if (label) label.textContent = before;
      // the data could not be read: the product page is the way to buy it
      if (opener && opener.href && !/\/products\//.test(location.pathname)) location.href = opener.href;
      else window.alert('Printeren kunne ikke hentes lige nu. Prøv igen om et øjeblik.');
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-printer-popup]');
    if (!a) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    e.stopPropagation();
    open({ trigger: a });
  }, true);

  M.printerPopup = { open: open };
})();
